var map = {
	"./CanvasClear": 49,
	"./CanvasClear.js": 49,
	"./CanvasMove": 50,
	"./CanvasMove.js": 50,
	"./CommandAbstract": 27,
	"./CommandAbstract.js": 27,
	"./ComponentDelete": 51,
	"./ComponentDelete.js": 51,
	"./ComponentDrag": 52,
	"./ComponentDrag.js": 52,
	"./ComponentEnter": 53,
	"./ComponentEnter.js": 53,
	"./ComponentExit": 54,
	"./ComponentExit.js": 54,
	"./ComponentNext": 55,
	"./ComponentNext.js": 55,
	"./ComponentPrev": 56,
	"./ComponentPrev.js": 56,
	"./ComponentStyleClear": 57,
	"./ComponentStyleClear.js": 57,
	"./CopyComponent": 58,
	"./CopyComponent.js": 58,
	"./DeleteComponent": 59,
	"./DeleteComponent.js": 59,
	"./ExportTemplate": 60,
	"./ExportTemplate.js": 60,
	"./Fullscreen": 61,
	"./Fullscreen.js": 61,
	"./MoveComponent": 62,
	"./MoveComponent.js": 62,
	"./OpenAssets": 63,
	"./OpenAssets.js": 63,
	"./OpenBlocks": 64,
	"./OpenBlocks.js": 64,
	"./OpenLayers": 65,
	"./OpenLayers.js": 65,
	"./OpenStyleManager": 66,
	"./OpenStyleManager.js": 66,
	"./OpenTraitManager": 67,
	"./OpenTraitManager.js": 67,
	"./PasteComponent": 68,
	"./PasteComponent.js": 68,
	"./Preview": 69,
	"./Preview.js": 69,
	"./Resize": 70,
	"./Resize.js": 70,
	"./SelectComponent": 20,
	"./SelectComponent.js": 20,
	"./SelectPosition": 32,
	"./SelectPosition.js": 32,
	"./ShowOffset": 71,
	"./ShowOffset.js": 71,
	"./SwitchVisibility": 72,
	"./SwitchVisibility.js": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;